import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const VERIFY_DOCUMENT_REQUEST = 'VERIFY_DOCUMENT_REQUEST'
export const VERIFY_DOCUMENT_SUCCESS = 'VERIFY_DOCUMENT_SUCCESS'
export const VERIFY_DOCUMENT_FAILURE = 'VERIFY_DOCUMENT_FAILURE'

export const verifyDocument = (identity, id) => ({
  [CALL_API]: {
    endpoint: '/api/identities/' + identity + '/accredited-investor-documents/' + id + '/make-verified/',
    types: [VERIFY_DOCUMENT_REQUEST, VERIFY_DOCUMENT_SUCCESS, VERIFY_DOCUMENT_FAILURE],
    method: 'PUT',
    tokenType: API_JWT_TOKEN_NAME,
    body: {},
  },
})
